import { useState, FC, useCallback, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';

import SettlementDetails from './SettlementDetails';

type ModalDetailsProps = {
  oid: number;
  isExport: string;
};

const ModalDetails: FC<ModalDetailsProps> = ({ oid, isExport }) => {
  const [isDialogShown, setIsDialogShown] = useState(false);
  const [isContentVisible, setIsContentVisible] = useState(false);
  const { t } = useTranslation('mySettlement');

  const toggleDialog = useCallback(() => {
    setIsDialogShown((prev) => !prev);
  }, []);

  const handleHide = useCallback(() => {
    setIsDialogShown(false);
    setIsContentVisible(false);
  }, []);

  useEffect(() => {
    if (isDialogShown) {
      const timeout = setTimeout(() => setIsContentVisible(true), 100);
      return () => clearTimeout(timeout);
    }
    return undefined;
  }, [isDialogShown]);

  const dialogHeader = (
    <div>
      <FontAwesomeIcon icon={faEye} style={{ marginRight: '0.5rem' }} />
      {t('seeContainers')}
    </div>
  );

  return (
    <div>
      <FontAwesomeIcon
        icon={faEye}
        onClick={toggleDialog}
        style={{ cursor: 'pointer' }}
      />

      <Dialog
        header={dialogHeader}
        visible={isDialogShown}
        breakpoints={{ '1200px': '95vw' }}
        onHide={handleHide}
        modal
      >
        {isContentVisible && (
          <SettlementDetails oid={oid} isExport={isExport} />
        )}
      </Dialog>
    </div>
  );
};

export default ModalDetails;
